module.exports = __webpack_public_path__ + "img/trunk_11x3_z16.667c46ca.svg";